// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import BurgerIcon from '../../_common/BurgerIcon';
import Cart from '../../_common/Cart';
import Icon from '../../_common/form/Icon';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import NotificationBubble from '../../_common/NotificationBubble';
import MenuRoutes from '../MenuRoutes';

const riseUp = keyframes`
    from{
        transform: translateY(101%)
    }
    to {
        transform: translateY(0%)
    }
`;
const Wrapper = styled.nav`
    align-self: flex-start;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme }) => theme.mobile.white};
    position: static;
    width: 100vw;
    bottom: 0;

    justify-content: flex-start;
    
    z-index: 99;

    animation: ${riseUp};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    box-shadow: 0px -2px 5px 0px ${({ theme }) => theme.mobile.shadow};
`

const NavItems = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-around;
    user-select: none;
`

const NavItem = styled.div`
    color: ${({ theme }) => theme.gray};
    padding: 1.5em 0 3.5em 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${({ size }) => size ? '20vw' : '25vw'};
    font-size: ${({ iconSize }) => iconSize ? '0.6em' : '1em'};
    text-align: center;

    transition: all 0.2s;

    ${({ theme, current }) => current && `
        color: ${theme.mobile.active};
        background-image: linear-gradient(#ffff0000, ${theme.mobile.active}40);
    `}
`
const NavLink = styled(Link)`
    text-decoration: none;
    -webkit-touch-callout: none;
`
const Label = styled.div`
    //visibility: ${({ show }) => show ? 'visible' : 'hidden'}
`
const Burger = styled(BurgerIcon)`
width: 30px;
height: 30px;
`

const NavBar = ({ isOpen, setIsOpen, ...props }) => {

    const { state: {
        cart,
        site_config,
        active_user
    } } = useGlobalState();

    const basePath = process.env.PUBLIC_URL;

    const isCurrent = current => {
        const currentPath = window.location.pathname.replace(basePath, '');
        return currentPath.length === 1 || current.length === 1 ? currentPath === current ? 1 : 0 : pathMatching(currentPath.split('/'), current.split('/')) ? 1 : 0
    };

    const pathMatching = (current, pointer) => {
        for (let i = 0; i < pointer.length; i++) {
            if (pointer[i] !== current[i]) return false;
        }
        return true;
    }

    const routes = MenuRoutes();

    return (
        <Wrapper id='NavigationBar'>
            <NavItems>
                <NavItem size={cart.length} iconSize={site_config.navWords} onClick={() => setIsOpen(true)}>
                    <NotificationBubble />
                    <Icon icon='bars' />
                    <Label>Menu</Label>
                </NavItem>
                <NavLink to={routes.home.route}>
                    <NavItem current={isCurrent(routes.home.route)} size={cart.length} iconSize={site_config.navWords}>
                        <Icon icon='home' />
                        <Label>{routes.home.label}</Label>
                    </NavItem>
                </NavLink>
                {/* 
                <NavLink to={menu.notifications.route}>
                    <NavItem current={isCurrent(menu.notifications.route)} size={cart.length} iconSize={site_config.navWords}>
                        <NotificationBubble />
                        <Label>{menu.notifications.label}</Label>
                    </NavItem>
                </NavLink> 
                */}
                <NavLink to={routes.myAccount.route}>
                    <NavItem current={isCurrent(routes.myAccount.route)} size={cart.length} iconSize={site_config.navWords}>
                        <Icon icon='user' />
                        <Label>{routes.myAccount.label}</Label>
                    </NavItem>
                </NavLink>
                <NavLink to={routes.wallet.route}>
                    <NavItem current={isCurrent(routes.wallet.route)} size={cart.length} iconSize={site_config.navWords}>
                        <Icon icon='wallet' />
                        <Label>{routes.wallet.label}</Label>
                    </NavItem>
                </NavLink>
                {active_user.isLoggedIn ?
                    <NavLink to={routes.checkout.route}>
                        <NavItem current={isCurrent(routes.checkout.route)} size={cart.length} iconSize={site_config.navWords}>
                            {Cart.Icon()}
                            <Label>{routes.checkout.label}</Label>
                        </NavItem>
                    </NavLink> : null}
            </NavItems>
        </Wrapper>
    );
}

export default NavBar;